(ns app.front.validate
  (:require [clojure.string :as str]
            [core.domain.validators :as validators]
            [core.util.schemas :as schemas]
            [schema.core :as s]))


(def Email schemas/Email)
(def PositiveNumber (s/pred #(and (number? %) (pos? %)) 'positive-number))
(def BlankOrEmail schemas/OptionalEmail)
(def BlankOrString (s/maybe s/Str))
(def NonBlankString schemas/NonBlankString)
(def NotEmptyList (s/pred (complement empty?) 'list-cannot-be-empty))
(def PasswordScore (s/pred #(contains? #{:good :moderate :not-applicable} %) 'weak-password))
(def PasswordBad (s/pred #(not= :not-applicable %) 'bad-password))
(def Phone (s/pred validators/valid-phone-number? 'phone-number))
(def BlankOrPhone (s/conditional str/blank? (s/pred str/blank?)
                                 :else Phone))
(def True (s/pred true?))


(def check-email (s/checker Email))


(defn validate [value [schema message]]
  (when (some? (s/check schema value)) message))


(defn validate-field [field form-data model]
  (let [value (get form-data field)]
    (some (partial validate value) (get model field))))


(defn validate-value [value schema-messages]
  (some (partial validate value) schema-messages))


(defn validate-form
  ([form-data model]
   (validate-form form-data model nil))
  ([form-data model tr]
   (->> form-data
        (map (fn [[field value]]
               (when-let [error (validate-value value (get model field))]
                 (if tr (tr [error]) error))))
        (filter some?))))


(defn validate-form-strict
  "Validate form model-first, so we'll also catch missing fields."
  [form-data model]
  (->> model
       (map (fn [[field field-model]]
              (validate-value (get form-data field) field-model)))
       (filter some?)))


(defn model-validator [form-data model]
  (fn [field] (validate-field field form-data model)))

(defn field-invalid?
  ([validator field]
   (field-invalid? true validator field))
  ([validate? validator field]
   (boolean (and validate? (some? (validator field))))))


(defn field-invalid-text
  ([validator field tr]
   (field-invalid-text true validator field tr))
  ([validate? validator field tr]
   (let [validator-result (validator field)]
     (or (when (and validate?
                    (keyword? validator-result))
           (tr [validator-result]))
         ""))))




(defn strip-nil-values
  "Strip `nil` values from a map."
  [hsh]
  (into (empty hsh) (remove (comp nil? last)) hsh))
